/*
 * Copyright (c) 2020. Sayari LLC
 */

import {Component} from '@angular/core';

@Component({
    selector: 'app-admin-navbar',
    templateUrl: './admin-navbar.component.html'
})
export class AdminNavbarComponent {
}